import { useMemo } from 'react';
import type { NotificationLevel } from '@/graphql/types';
import { NotificationBorderVariants } from '../enums';

type NotificationCheckboxProps = {
    level: NotificationLevel;
    isChecked: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function NotificationCheckbox({
    level,
    isChecked,
    onChange,
}: NotificationCheckboxProps): JSX.Element {
    const borderClass = useMemo(() => NotificationBorderVariants[level], [level]);
    const notificationLevelLabels = useMemo(
        () =>
            ({
                success: gettext('NOTIFICATION_LEVEL_SUCCESS'),
                info: gettext('NOTIFICATION_LEVEL_INFO'),
                warning: gettext('NOTIFICATION_LEVEL_WARNING'),
                error: gettext('NOTIFICATION_LEVEL_ERROR'),
            } as const satisfies Record<NotificationLevel, string>),
        []
    );

    return (
        <div
            className={`border-notification-border flex-1 border border-l-4 ${borderClass} bg-white py-2 pl-1 pr-3`}
        >
            <div className="flex items-center">
                <input
                    className="mx-2.5"
                    type="checkbox"
                    id={`notification-checkbox-${level}`}
                    name={`level-${level}`}
                    value={level}
                    checked={isChecked}
                    onChange={onChange}
                    aria-label={interpolate(
                        gettext('NOTIFICATION_LEVEL_CHECKBOX'),
                        { level },
                        true
                    )}
                />
                <label htmlFor={`notification-checkbox-${level}`}>
                    {notificationLevelLabels[level]}
                </label>
            </div>
        </div>
    );
}

export default NotificationCheckbox;
